import * as React from "react";
import type { SVGProps } from "react";
const SvgPaypalBadge = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 35 24"
    {...props}
  >
    <rect
      width={34}
      height={23}
      x={0.5}
      y={0.5}
      fill="#fff"
      stroke="#D9D9D9"
      rx={3.5}
    />
    <path
      fill="#253B80"
      fillRule="evenodd"
      d="M9.9 15.241H8.344a.216.216 0 0 0-.213.182l-.63 3.99a.13.13 0 0 0 .129.15h.743a.216.216 0 0 0 .213-.183l.17-1.076a.216.216 0 0 1 .213-.183h.493c1.024 0 1.616-.496 1.77-1.479q.104-.647-.198-1.004c-.221-.26-.613-.397-1.134-.397m.18 1.457c-.086.558-.512.558-.924.558H8.92l.164-1.042a.13.13 0 0 1 .129-.11h.107c.281 0 .546 0 .683.16.082.096.107.238.075.434m4.47-.018h-.745a.13.13 0 0 0-.128.11l-.033.208-.052-.076c-.161-.234-.52-.312-.88-.312-.823 0-1.526.624-1.663 1.498-.071.436.03.854.277 1.144.227.268.552.38.939.38.663 0 1.03-.427 1.03-.427l-.032.207a.13.13 0 0 0 .127.15h.672a.216.216 0 0 0 .213-.183l.403-2.55a.13.13 0 0 0-.128-.149m-1.038 1.45a.83.83 0 0 1-.84.711c-.217 0-.39-.07-.5-.2-.111-.131-.153-.317-.118-.524a.834.834 0 0 1 .835-.717c.211 0 .383.07.497.203.113.134.158.32.126.527m4.257-1.45h.749a.13.13 0 0 1 .106.204l-2.49 3.593a.22.22 0 0 1-.178.093h-.747a.13.13 0 0 1-.106-.204l.775-1.095-.824-2.42a.13.13 0 0 1 .123-.171h.735c.096 0 .18.063.208.154l.438 1.462 1.032-1.521a.22.22 0 0 1 .179-.095"
      clipRule="evenodd"
    />
    <path
      fill="#179BD7"
      fillRule="evenodd"
      d="m25.885 19.412.639-4.062a.13.13 0 0 1 .128-.11h.718c.08 0 .14.072.128.15l-.63 3.99a.216.216 0 0 1-.213.182h-.642a.13.13 0 0 1-.128-.15m-4.889-4.171H19.44a.216.216 0 0 0-.213.182l-.63 3.99a.13.13 0 0 0 .128.15h.799a.15.15 0 0 0 .15-.129l.178-1.13a.216.216 0 0 1 .213-.183h.492c1.025 0 1.616-.496 1.771-1.479q.104-.647-.198-1.004c-.221-.26-.613-.397-1.134-.397m.18 1.457c-.085.558-.512.558-.924.558h-.235l.165-1.042a.13.13 0 0 1 .128-.11h.107c.281 0 .546 0 .683.16.082.096.107.238.075.434m4.47-.018H24.9a.13.13 0 0 0-.128.11l-.033.208-.052-.076c-.161-.234-.52-.312-.88-.312-.823 0-1.526.624-1.663 1.498-.07.436.03.854.278 1.144.227.268.552.38.938.38.663 0 1.031-.427 1.031-.427l-.033.207a.13.13 0 0 0 .128.15h.671a.216.216 0 0 0 .213-.183l.403-2.55a.13.13 0 0 0-.128-.149m-1.039 1.45a.83.83 0 0 1-.84.711c-.216 0-.39-.07-.5-.2-.11-.131-.152-.317-.117-.524a.834.834 0 0 1 .835-.717c.211 0 .383.07.496.203a.64.64 0 0 1 .126.527"
      clipRule="evenodd"
    />
    <path
      fill="#253B80"
      d="m15.657 13.814.191-1.215-.426-.01h-2.034l1.414-8.964a.116.116 0 0 1 .115-.098h3.43c1.138 0 1.924.237 2.334.705.193.22.315.449.375.701.062.265.063.581.002.967l-.004.028v.247l.192.11q.241.127.39.296.247.283.316.709c.046.29.03.636-.046 1.028-.087.45-.23.843-.42 1.164q-.267.445-.668.731a2.7 2.7 0 0 1-.899.406c-.331.086-.709.13-1.123.13h-.267a.807.807 0 0 0-.794.678l-.02.109-.338 2.14-.016.08q-.006.035-.02.045a.06.06 0 0 1-.036.013z"
    />
    <path
      fill="#179BD7"
      d="M21.428 5.957q-.015.098-.035.2c-.452 2.323-2 3.125-3.976 3.125H16.41a.49.49 0 0 0-.483.414l-.515 3.268-.146.926a.257.257 0 0 0 .254.298h1.785a.43.43 0 0 0 .424-.362l.018-.09.336-2.133.022-.117a.43.43 0 0 1 .424-.363h.267c1.729 0 3.083-.702 3.478-2.734.166-.849.08-1.557-.357-2.056a1.7 1.7 0 0 0-.489-.376"
    />
    <path
      fill="#222D65"
      d="M20.955 5.768a4 4 0 0 0-.44-.098 5.6 5.6 0 0 0-.887-.064h-2.689a.426.426 0 0 0-.424.362l-.572 3.623-.016.106a.49.49 0 0 1 .483-.414h1.006c1.977 0 3.525-.803 3.977-3.125q.02-.103.035-.201a2.4 2.4 0 0 0-.473-.189"
    />
    <path
      fill="#253B80"
      d="M16.516 5.968a.43.43 0 0 1 .423-.362h2.689q.479-.001.887.065a4 4 0 0 1 .44.097l.102.032q.2.066.371.157c.135-.859 0-1.443-.465-1.972-.511-.583-1.435-.832-2.616-.832h-3.43a.49.49 0 0 0-.485.414l-1.428 9.056c-.028.18.11.341.29.341h2.118l.532-3.373z"
    />
  </svg>
);
export default SvgPaypalBadge;
